/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import { imagePath } from '../../utils/ImagePath'
import styled from '@emotion/styled'

export const BackButton = ({ ...props }) => {
  return (
    <button css={backButtonStyle} {...props}>
      <ArrowIconWrapper>
        <ArrowIcon
          src={imagePath('details_back_button_arrow.svg')}
          alt=""
          width="25px"
          height="25px"
        />
      </ArrowIconWrapper>
    </button>
  )
}

const backButtonStyle = css`
  background-color: white;
  border-radius: 50%;
  width: 35px;
  height: 35px;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
`

const ArrowIconWrapper = styled.span(css`
  position: relative;
  width: 35px;
  height: 35px;
`)

const ArrowIcon = styled.img(css`
  position: absolute;
  object-fit: cover;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  width: 25px;
  height: 25px;
`)
